export const MANAGED_ACCOUNT_TYPE = Object.freeze({
  PAYMENTS_MANAGER: 'payments_manager',
  POSITIVE_PAY: 'positive_pay',
});

export const MANAGED_ACCOUNT_PROVIDER = Object.freeze({
  WELLS_FARGO: 'wells_fargo',
});

export const MANAGED_ACCOUNT_TYPE_TRANSLATION_KEY = Object.freeze({
  [MANAGED_ACCOUNT_TYPE.PAYMENTS_MANAGER]:
    'managedAccounts.list.type.paymentsManager',
  [MANAGED_ACCOUNT_TYPE.POSITIVE_PAY]: 'managedAccounts.list.type.positivePay',
});

export const MANAGED_ACCOUNT_PROVIDER_TRANSLATION_KEY = Object.freeze({
  [MANAGED_ACCOUNT_PROVIDER.WELLS_FARGO]:
    'managedAccounts.list.provider.wellsFargo',
});

export const SFTP_AUTHENTICATION_MODE = Object.freeze({
  PASSWORD: 'password',
  SSH_KEY: 'ssh_key',
});

export const SECTION_GRID_SPACING = 3;
export const SECTION_BOTTOM_MARGIN = 5;
